import { Amount, CurrencyIso } from '@/features/admin/rents/types';

type CurrencyMap = {
  [key in CurrencyIso]: string;
};

const currencyMap: CurrencyMap = {
  EUR: '€',
  USD: '$',
};

const currencyIsoToString = (currencyIso: CurrencyIso): string => {
  return currencyMap[currencyIso];
};

function currencyFormat(amount: number, currency: string) {
  // Ensure currency is a valid ISO code, default to EUR if invalid
  const validCurrency = ['EUR', 'USD'].includes(currency) ? currency : 'EUR';
  const locale = validCurrency === 'USD' ? 'en-US' : 'de-DE';
  
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: validCurrency,
  }).format(amount);
}

const amountToString = (amount: Amount) => {
  const centsToFull = amount.cents / 100;
  // Ensure we have a valid currency_iso
  const currency = amount.currency_iso || amount.currency || 'EUR';
  
  return currencyFormat(centsToFull, currency);
};

const numberToCurrency = (amount: Number, currency_iso = 'EUR') => {
  return `${currencyIsoToString(currency_iso)}${amount}`;
};

export { amountToString, currencyFormat, currencyIsoToString, numberToCurrency };
